import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxOptional } from '@onyx/angular';
import {
  OnyxButtonComponent,
  OnyxIconComponent,
  OnyxInformationHeadingComponent,
  OnyxMessageComponent,
} from '@onyx/angular';
import { OrderHelper } from '../../../../../dashboard/orders/common/helpers/order.helper';

@Component({
  selector: 'app-no-active-order',
  imports: [
    OnyxInformationHeadingComponent,
    OnyxMessageComponent,
    OnyxIconComponent,
    OnyxButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './no-active-order.component.html',
  styleUrl: './no-active-order.component.scss',
})
export class NoActiveOrderComponent {
  protected readonly orderHelper = inject(OrderHelper);

  public readonly manualProposalOrderUuid = input<OnyxOptional<string>>();
}
